'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var MIN_PASSWORD_LENGTH = 6;
var isPassword = function (password) {
    var value = (password || '').toLowerCase();
    return value.length >= MIN_PASSWORD_LENGTH;
};

exports.MIN_PASSWORD_LENGTH = MIN_PASSWORD_LENGTH;
exports.default = isPassword;
//# sourceMappingURL=index.js.map
